import { billing, UpgradeSource } from 'common/billing'
import { getConnectionBlockedActiveTrialPaywall } from 'common/billing/components/ConnectionBlockedActiveTrialPaywalls/constants'
import { alert } from 'common/core'
import { Ability } from 'common/core/constants/Ability'
import { ChannelType } from 'common/core/constants/ChannelType'

export const alertConnectionRestricted = (message: string) => {
  alert(message, 'danger', { isTemporary: false })
}

export const alertConnectionBlockedActiveTrial = (channel: ChannelType) => {
  billing.requestUpgrade({
    source: UpgradeSource.CONNECTION_BLOCKED_ACTIVE_TRIAL,
    abilities: [Ability.PAID_AUTOMATIONS],
    requestPaid: true,
    paywall: getConnectionBlockedActiveTrialPaywall(channel),
  })
}
